// @flow

import { connect } from 'react-redux';

import { selectCartIsWorking, updateCartProduct } from '@gandi/cart';

import { formValueSelector } from 'gandi.react-form';
import { POST } from 'gandi.redux-fetcher';

import { selectPasswordServiceURL } from '../../../../components/PasswordChecker';

import type { FullState, Dispatch } from '../../../../types';

import Presenter, {
  type PresenterDispatchProps,
  type PresenterStateProps,
} from './Presenter';

const selectFormValue = formValueSelector('cloud-create-server');

const mapStateToProps = (state: FullState): PresenterStateProps => ({
  cartIsWorking: selectCartIsWorking(state),
  isPasswordSet: !!selectFormValue(state, 'password'),
  // $FlowFixMe[incompatible-return]
  username: selectFormValue(state, 'username'),
  passwordService: selectPasswordServiceURL(state),
});

const mapDispatchToProps = (dispatch: Dispatch): PresenterDispatchProps => ({
  updateCartProduct: (...args) => dispatch(updateCartProduct(...args)),
  POST: (...args) => dispatch(POST(...args)),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps, mapDispatchToProps)(Presenter);
